/**
 * Shared notification link resolution utilities.
 *
 * Centralizes the logic for rewriting stale notification links
 * (from before PR #138) used in ActionItems and NotificationPanel.
 */

/**
 * Rewrite stale notification links from before PR #138.
 *
 * Old notifications may have `/email-routing` links stored in the DB;
 * these should navigate to `/portal/inbox` (with emailId if available).
 */
export function resolveNotificationLink(
  link: string | null,
  extraData: Record<string, unknown> | null,
): string | null {
  // A Quality door answer opens that answer's drawer (proposal 1), also for
  // bell rows written before the server linked there (they pointed at the
  // case or the bare door).
  const requestId = extraData?.data_request_id;
  if (extraData?.kind === 'response_arrived' && typeof requestId === 'string' && requestId) {
    return `/portal/quality-copilot?answer=${encodeURIComponent(requestId)}`;
  }
  if (!link) return null;
  if (link === '/email-routing' || link.startsWith('/email-routing')) {
    const emailId = extraData?.email_id as string | undefined;
    return emailId ? `/portal/inbox?emailId=${emailId}` : '/portal/inbox';
  }
  return link;
}
